import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import categoryc1CategoryUrlId from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { path as c1SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { matchPathWithLocale } from "@faire/web/ui/routing/react-utils";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useConductorSurface = (): keyof typeof ConductorSurface => {
  const { pathname } = useLocation();

  const isInsiderLandingPage = matchPathWithLocale(
    pathname,
    categoryc1CategoryUrlId("Insider")
  );

  const isAllBrandsPage = matchPathWithLocale(
    pathname,
    decodeURI(c1SuppliersPath("All Brands"))
  );

  return useMemo(() => {
    switch (true) {
      case isInsiderLandingPage:
        return ConductorSurface.INSIDER_LANDING_PAGE_BANNER;
      case isAllBrandsPage:
        return ConductorSurface.MARKET_ANNOUNCEMENT_BANNER;
      default:
        return ConductorSurface.CONDUCTOR_SURFACE_UNKNOWN;
    }
  }, [isInsiderLandingPage, isAllBrandsPage]);
};
